export const DRAWER_WIDTH = 100
export const LOGO_HEIGHT = 70
